import AuthLayout from '@/components/auth/auth-layout';
import { DesktopLoginLayout } from '@/components/auth/desktop-login-layout';
import { MobileAuthLayout } from '@/components/auth/mobile-auth-layout';
import { isDesktopPlatform } from '@/lib/desktop/bridge';
import { isNativePlatform } from '@/lib/mobile/platform';

import type { ReactNode } from 'react';

interface AuthRouteLayoutProps {
  readonly children: ReactNode;
}

/**
 * Picks the shell for whichever app is hosting the auth route. Native was
 * missing, so every route the sign-in sheet navigates to fell through to the
 * web layout - marketing nav, desktop-sized watermark, no safe-area insets.
 */
export function AuthRouteLayout({ children }: AuthRouteLayoutProps) {
  if (isNativePlatform()) {
    return <MobileAuthLayout>{children}</MobileAuthLayout>;
  }
  return isDesktopPlatform() ? (
    <DesktopLoginLayout>{children}</DesktopLoginLayout>
  ) : (
    <AuthLayout>{children}</AuthLayout>
  );
}
